module.exports = __webpack_public_path__ + "img/c-en-02.a4e0d689.png";